/* eslint-disable spaced-comment */
import React, { PureComponent } from 'react';
import validator from '../util/validator';

class PhoneInput extends PureComponent {
  state = {
    value: '',
    isFocused: false,
    isTouched: false,
    isValid: false,
  };

  formatPhoneNumber = (inputValue) => {
    let formattedValue;
    let input = inputValue ? inputValue.replace(/\D/g, '') : '';
  
    input = input.substring(0, 10);
    const size = input.length;
  
    if (size === 0) {
      formattedValue = input;
    } else if (size < 4) {
      formattedValue = `(${input}`;
    } else if (size < 7) {
      formattedValue = `(${input.substring(0, 3)}) ${input.substring(3, 6)}`;
    } else {
      formattedValue = `(${input.substring(0, 3)}) ${input.substring(3, 6)}-${input.substring(6, 10)}`;
    }
    return formattedValue;
  }

  /**
   * Sets focused state
   */
  handleFocus = () => this.setState({ isFocused: true })

  /**
   * Sets focused and touched state
   */
  handleBlur = () => this.setState({ isFocused: false, isTouched: true })

  /**
   * Checks validity, updates state, and call parent's event handler
   * @param {object} e - The Event object
   */
  handleChange = ({ target: { value } }) => {
    value = value.replace(/\D/g, '');
    
    const { eventHandler, validationRules, inputKey } = this.props;
    
    const isValid = validator(validationRules, value);
    
    this.setState({ value, isValid });

    eventHandler(value, inputKey, isValid);
  }
  /**
   * Render UI
   */
  render() {
    const {
      props: {
        invalidFormSubmitted,
        label,
        placeholder,
        errorMessage,
        inputClassName = '',
        required
      },
      state: {
        value,
        isValid,
        isTouched,
        isFocused,
      } 
    } = this;
    
    const isErrorState = (!isValid && !isFocused && isTouched)
      || (!isValid && invalidFormSubmitted && !isFocused);

    const validLength = value && String(value).length > 0;

    let outerwrapState = '';
    if (isValid && validLength) outerwrapState = '--valid';
    else if (isFocused) outerwrapState = '--focused';
    else if (isErrorState) outerwrapState = '--error';

    const labelState = (isFocused || (value && String(value).length > 0)) ? '--up' : '';

    return (
      <div className={`formInput ${inputClassName}`}>
        <label htmlFor="formInput__label">{ label }</label>
        <div
          onClick={() => this.input && this.input.focus()}
          className={`formInput__placeholder${labelState} formInput__placeholder${outerwrapState}`}
        >
          { placeholder }
        </div>
        {(isErrorState && required) && (
          <div
            onClick={() => this.input && this.input.focus()}
            className={`formInput__required`}
          >
            { errorMessage }
          </div>
        )}
        <input
          value={this.formatPhoneNumber(value)}
          maxLength={14}
          minLength={14}
          onBlur={this.handleBlur}
          onFocus={this.handleFocus}
          onChange={this.handleChange}
          ref={(input) => { this.input = input }}
          className={`formInput__input${outerwrapState}`}
          autoComplete="nope"
        />
      </div>
    );
  }
}

export default PhoneInput;



// WEBPACK FOOTER //
// ./src/features/agent-info-verification/common/PhoneInput.js